var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { v4 as uuidv4 } from "uuid";
import { supabase } from '../../libs/supabaseClient';
var PREFERENCES_TABLE = "financial_institution_preferences";
var BUCKET = 'financial-institution-logo';
/**
 * Obtiene los preferences de la tabla `financial_institution_preferences`
 */
export function getPreferences(financialInstitutionId) {
    var _a, _b, _c, _d, _e;
    return __awaiter(this, void 0, void 0, function () {
        var _f, institutionData, error, error_1;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    _g.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, supabase
                            .from(PREFERENCES_TABLE)
                            .select("*")
                            .eq("financial_institution", financialInstitutionId)];
                case 1:
                    _f = _g.sent(), institutionData = _f.data, error = _f.error;
                    if (error)
                        throw error;
                    return [2 /*return*/, {
                            institutionId: (_a = institutionData === null || institutionData === void 0 ? void 0 : institutionData[0]) === null || _a === void 0 ? void 0 : _a.financial_institution,
                            createdAt: (_b = institutionData === null || institutionData === void 0 ? void 0 : institutionData[0]) === null || _b === void 0 ? void 0 : _b.created_at,
                            accountCardColor: (_c = institutionData === null || institutionData === void 0 ? void 0 : institutionData[0]) === null || _c === void 0 ? void 0 : _c.account_card_color,
                            accountTextColor: (_d = institutionData === null || institutionData === void 0 ? void 0 : institutionData[0]) === null || _d === void 0 ? void 0 : _d.account_text_color,
                            logo: ((_e = institutionData === null || institutionData === void 0 ? void 0 : institutionData[0]) === null || _e === void 0 ? void 0 : _e.logo) || '',
                        }];
                case 2:
                    error_1 = _g.sent();
                    console.error("Error losding preferences:", error_1);
                    throw error_1;
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * Actualiza los preferences de la tabla `financial_institution_preferences`
 */
export function updatePreferences(financialInstitutionId, preferences) {
    return __awaiter(this, void 0, void 0, function () {
        var _a, data, error, error_2;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, supabase
                            .from(PREFERENCES_TABLE)
                            .update(preferences)
                            .eq("financial_institution", financialInstitutionId)];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (error)
                        throw error;
                    return [2 /*return*/, data];
                case 2:
                    error_2 = _b.sent();
                    console.error("Error updating preferences:", error_2);
                    return [2 /*return*/, null];
                case 3: return [2 /*return*/];
            }
        });
    });
}
/**
 * Subir logo al bucket de supabase
 */
export function uploadLogo(file) {
    return __awaiter(this, void 0, void 0, function () {
        var id, filePath, _a, data, error, publicUrlData, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 3, , 4]);
                    id = uuidv4();
                    filePath = "logo/".concat(id);
                    return [4 /*yield*/, supabase.storage
                            .from(BUCKET)
                            .upload(filePath, file, {
                            cacheControl: "3600",
                        })];
                case 1:
                    _a = _b.sent(), data = _a.data, error = _a.error;
                    if (error)
                        throw error;
                    return [4 /*yield*/, supabase.storage
                            .from(BUCKET)
                            .getPublicUrl(filePath)];
                case 2:
                    publicUrlData = (_b.sent()).data;
                    return [2 /*return*/, publicUrlData.publicUrl]; // ahora retorna la URL pública directamente
                case 3:
                    error_3 = _b.sent();
                    console.error("Error uploading logo:", error_3);
                    return [2 /*return*/, null];
                case 4: return [2 /*return*/];
            }
        });
    });
}
